import { MsalProvider } from '@azure/msal-react';
import { useEffect, useState, type ReactNode } from 'react';
import { msalInstance } from './msalConfig';

export function AuthProvider({ children }: { children: ReactNode }) {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    msalInstance.initialize().then(() => setInitialized(true));
  }, []);

  if (!initialized) return null;
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
